import React, { useState, useEffect } from 'react'
import './result.css'
import '../loader/loader.css'
import Cookies from 'js-cookie'
import { isAndroid } from 'react-device-detect'
import { FacebookIcon, FacebookShareButton, TwitterIcon, TwitterShareButton, PinterestIcon, PinterestShareButton, RedditIcon, RedditShareButton, WhatsappIcon, WhatsappShareButton } from 'react-share'
import { FaShare } from 'react-icons/fa'

import countVisitors from '../../hooks/countVisitors'
import geniewait from '../../assets/geniewait.mp4'
import genietalk from '../../assets/genietalk.mp4'

const Result = ({ windowSize, loading, setBackEvents, result, details, resultState, setResultState, seeMoreState, setSeeMoreState, setChatState }) => {
    const [changeScroll, setChangeScroll] = useState(false)
    const [totalHeightState, setTotalHeightState] = useState(false)

    // useEffect(() => {
    //     const resultCall = document.getElementById('resultCall')
    //     const pagesCall = document.getElementById('pagesCall')

    //     try {
    //         resultCall.appendChild(pagesCall)
    //     } catch (error) {
    //         console.log(error);            
    //     }
    // }, [])

    useEffect(() => {
        if (document.getElementById("typeWriter")) {
            document.getElementById("typeWriter").innerHTML = '';
        }

        if (result !== '') {
            setResultState(e => {return {...e, video: true}})
            setSeeMoreState(e => {return {...e, animation: false}})
            
            setTimeout(() => {
                setSeeMoreState(e => {return {...e, display: false}})
            }, 500);
        }
    }, [result]);

    useEffect(() => {
        let counter = 0;
        function animateResult() {
            if (document.getElementById("typeWriter")) {
                document.getElementById("typeWriter").innerHTML += result.charAt(counter);
                counter++;
                
                if (result !== "Espera un segundo! El genio esta frotando la lampara para ti" && counter === result.length) {
                    window.TiktokPixel(window, document, 'ttq');
                    countVisitors({ page: 'spanish2-chat' })
    
                    setResultState(e => {return {...e, animation: false, events: false, video: false}})
                    setChatState(e => {return {...e, display: true}})
                    setSeeMoreState(e => {return {...e, display: true}})
                    setBackEvents(true)
                    setTotalHeightState(prev => !prev);

                    const resultTimeout = setTimeout(() => {
                        setResultState(e => {return {...e, display: false}})
                        setChatState(e => {return {...e, animation: true}})
                        setSeeMoreState(e => {return {...e, animation: true}})
                    }, 500);

                    const chatTimeOut = setTimeout(() => {
                        setChatState(e => {return {...e, events: true}})
                    }, 1000);

                    return () => {clearTimeout(resultTimeout); clearTimeout(chatTimeOut);}
                }
            }

        }

        let timerID = setInterval(animateResult.bind(animateResult), 70);

        return () => clearInterval(timerID)
    }, [result]); 

    useEffect(() => {
        if (document.getElementById("typeWriter")) {
            let contentHeight = document.getElementById('typeWriter').offsetHeight + 380;
            if (contentHeight > windowSize.height) {
                setChangeScroll(true)
            } else {
                setChangeScroll(false)
            }
        }
    }, [totalHeightState, windowSize])

    // const handleSeeMore = () => {
    //     setSeeMoreState(e => {return {...e, animation: false}})
    //     setEmailDisplay(true)
        
    //     setTimeout(() => {
    //         setSeeMoreState(e => {return {...e, display: false}})
    //         setEmailAnimation(true)
    //     }, 500);
    // }

    return (
        <div className="result" style={{ display: (resultState.display) ? 'flex' : 'none', opacity: (resultState.animation) ? 1 : 0, pointerEvents: (resultState.events) ? 'all' : 'none' }}>
            {/* <div id='resultCall'></div> */}
            <div className="resultWrapper" style={{ overflowY: (changeScroll) ? 'overlay' : 'visible', justifyContent: (changeScroll) ? 'flex-start' : 'center' }}>
                <div className='resultVideoWrapper'>
                    <div style={{ opacity: (!resultState.video && !loading) ? 1 : 0 }} dangerouslySetInnerHTML={{ __html: `
                        <video
                        loop
                        muted
                        autoplay
                        playsinline
                        src="${geniewait}"
                        class="genieVideo"
                        />
                    ` }}></div>
                    <div style={{ opacity: (resultState.video &&  !loading) ? 1 : 0 }} dangerouslySetInnerHTML={{ __html: `
                        <video
                        loop
                        muted
                        autoplay
                        playsinline
                        src="${genietalk}"
                        class="genieVideo"
                        />
                    ` }}></div>
                    <div style={{ opacity: (loading) ? 1 : 0 }}>
                        <img id='genieGIF' src="https://media3.giphy.com/media/tpTOw6sljB2U/100.gif?cid=68dd81416dc5748561f7863dc6021b460906ffe535438b4b&rid=100.gif&ct=g" alt="dsad" />
                    </div>
                </div>

                <p className='resultTitle' style={{ opacity: (resultState.animation) ? 1 : 0 }}>Horoscopo</p>
                <div className='resultSubTitle' style={{ opacity: (resultState.animation) ? 1 : 0 }}>
                    <div style={{ flex: 1 }}>
                        {details.zodiac}
                    </div>
                    <div>
                        &nbsp;x&nbsp;
                    </div>
                    <div style={{ flex: 1 }}>
                        {details.color}
                    </div>
                </div>

                <p id='typeWriter'></p>
                
                {/* <div className='resultSeeMore' style={{ display: (seeMoreState.display) ? 'flex' : 'none', opacity: (seeMoreState.animation) ? 1 : 0 }}>
                    <button onClick={() => {handleSeeMore(); setTimeout(() => {setTotalHeightState(prev => !prev)}, 200);}}>
                        HAZ CLICK AQUI PARA PREGUNTARLE MAS A NUESTRO GENIO
                    </button>
                </div> */}

                {/* <div className="social-share" style={{ display: (emailDisplay) ? 'flex' : 'none', opacity: (emailAnimation) ? 1 : 0 }}>
                    <p>Comparte En Tus Redes Sociales<FaShare size={20} color={'#FFFFFF'} style={{ marginLeft: '5px' }}/></p>

                    <div>
                        {(isAndroid) ? (
                            <a className='social-share-icon' href={`fb://faceweb/f?href=https://m.facebook.com/sharer/sharer.php?u=${window.location.protocol.replace(':', '')}%3A%2F%2F${window.location.host}%2F&amp;src=sdkpreparse`}>
                                <FacebookIcon size={40} round={true}/>
                            </a>
                        ) : (
                            <FacebookShareButton className='social-share-icon' url={window.location.href} quote={`Hi everyone.\nCheck out this website to know your future.\nHere's mine.\n\n${result}\n\n`} hashtag={'#horoscopegenie'}>
                                <FacebookIcon size={40} round={true}/>
                            </FacebookShareButton>
                        )}
                        <TwitterShareButton className='social-share-icon' url={window.location.href} title={`Hi everyone.\nCheck out this website to know your future.\nHere's mine.\n\n${result}\n\n`}>
                            <TwitterIcon size={40} round={true}/>
                        </TwitterShareButton>
                        <RedditShareButton className='social-share-icon' url={window.location.href} title={`Hi everyone.\nCheck out this website to know your future.\nHere's mine.\n\n${result}\n\n`}>
                            <RedditIcon size={40} round={true}/>
                        </RedditShareButton>
                        <PinterestShareButton className='social-share-icon' url={window.location.href} media={'https://i.postimg.cc/3RXsdRFr/logo-Small.png'} description={`Hi everyone.\nCheck out this website to know your future.\nHere's mine.\n\n${result}\n\n`}>
                            <PinterestIcon size={40} round={true}/>
                        </PinterestShareButton>
                        <WhatsappShareButton className='social-share-icon' url={window.location.href} title={`Hi everyone.\nCheck out this website to know your future.\nHere's mine.\n\n${result}\n\n`} separator={''}>
                            <WhatsappIcon size={40} round={true}/>
                        </WhatsappShareButton>
                    </div>
                </div> */}
            </div>
        </div>
    )
}

export default Result